/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsProductTypeListItem
 */
export interface DigitizingserviceMelcoDigitizingModelsProductTypeListItem {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsProductTypeListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsProductTypeListItem
     */
    name?: string | null;
}

export function DigitizingserviceMelcoDigitizingModelsProductTypeListItemFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsProductTypeListItem {
    return DigitizingserviceMelcoDigitizingModelsProductTypeListItemFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsProductTypeListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsProductTypeListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function DigitizingserviceMelcoDigitizingModelsProductTypeListItemToJSON(value?: DigitizingserviceMelcoDigitizingModelsProductTypeListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


